import { Navigate, useParams } from "react-router-dom";
import SavePreagendamientoVenta from "../../shared/componente/SavePreagendamiento/SavePreagendamientoVenta";
import { useGetPreventaById } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { ROUTER_PATHS } from "@/shared";

export default function CreatePreagendamientoPage() {

  const { id } = useParams();

  const {
    isLoading,
    data,
  } = useGetPreventaById(id!);

 
  if (isLoading)
    return <LoaderComponent />

  if(!data)
    return <Navigate to={ROUTER_PATHS.ventas.preventasNav}/>

  return (
    <SavePreagendamientoVenta
      title="Crear Preagendamiento"
      dataPreventa={data}
    />
  )

}